import { render, staticRenderFns } from "./popper.vue?vue&type=template&id=47598493&scoped=true&"
import script from "./popper.vue?vue&type=script&lang=js&"
export * from "./popper.vue?vue&type=script&lang=js&"
import style0 from "./popper.vue?vue&type=style&index=0&id=47598493&lang=scss&scoped=true&"
import style1 from "./popper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47598493",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47598493')) {
      api.createRecord('47598493', component.options)
    } else {
      api.reload('47598493', component.options)
    }
    module.hot.accept("./popper.vue?vue&type=template&id=47598493&scoped=true&", function () {
      api.rerender('47598493', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/popper/popper.vue"
export default component.exports